import React from 'react';
import './Shows.css';

function Shows() {
  const upcomingShows = [
    {
      date: '2025-04-15',
      venue: 'Openmic Generator',
      city: 'Barcelona',
      ticketLink: 'https://ticketek.com.ar'
    },
    {
      date: '2025-04-19',
      venue: 'Onda Ground',
      city: 'Barcelona',
      ticketLink: 'https://redtickets.uy'
    },
    {
      date: '2025-05-22',
      venue: 'Balt Session',
      city: 'Barcelona',
      ticketLink: 'https://redtickets.uy'
    }
  ];

  return (
    <div className="shows-section">
      <h2>Próximos Shows</h2>
      
      <div className="upcoming-shows">
        <div className="shows-list">
          {upcomingShows.map((show, index) => (
            <div key={index} className="show-item">
              <div className="show-date">
                {new Date(show.date).toLocaleDateString('es-AR', {
                  day: 'numeric',
                  month: 'long'
                })}
              </div>
              <div className="show-info">
                <span className="venue">{show.venue}</span>
                <span className="city">{show.city}</span>
              </div>
              {show.ticketLink && (
                <a href={show.ticketLink} className="ticket-link" target="_blank" rel="noopener noreferrer">
                  Tickets
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Shows; 